import { styled } from "@mui/material";
import {
  CenteredBox,
  type CenteredBoxProps,
} from "@/components/baseComponents/CenteredBox";
import { CONTENT_WIDTH } from "@/utils/styles.constants";
import { FOOTER_HEIGHT } from "./footer.constants";

export const StyledContainer = styled((props: CenteredBoxProps) => (
  <CenteredBox component="footer" {...props} />
))(({ theme }) => ({
  padding: `28px max(calc((100% - ${CONTENT_WIDTH}) / 2), 20px) 12px`,
  minHeight: FOOTER_HEIGHT,
  color: theme.palette.text.disabled,
  textAlign: "center",
}));
